import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import PrivateComposing from './PrivateComposing';
import PrivateHero from '../components/PrivateHero';
export default function PrivateDiscussionsPage() {
  extend(IndexPage.prototype, 'oninit', function () {
    if (app.current.get('routeName') === 'byobuPrivate' && !app.previous.matches(IndexPage)) {
      app.discussions.clear();
      app.discussions.refresh();
    }
  });
  extend(IndexSidebar.prototype, 'navItems', items => {
    const user = app.session.user;
    if (user) {
      items.add('privateDiscussions', LinkButton.component({
        icon: app.forum.data.attributes['byobu.icon-badge'],
        href: app.route('byobuPrivate')
      }, app.translator.trans('fof-byobu.forum.nav.nav_item')), 75);
    }
  });
  extend(IndexPage.prototype, 'setTitle', function () {
    if (app.current.get('routeName') === 'byobuPrivate') {
      app.setTitle(app.translator.trans('fof-byobu.forum.user.dropdown_label'));
    }
  });
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (app.current.get('routeName') === 'byobuPrivate') {
      // Apply the private filter directly to the API request params
      params.filter.private = true;

      // Include recipient relations
      params.include.push('recipientUsers');
      params.include.push('recipientGroups');
    }
  });
  extend(IndexSidebar.prototype, 'items', function (items) {
    if (app.current.get('routeName') === 'byobuPrivate') {
      let compose = new PrivateComposing();
      items.setContent('newDiscussion', compose.component());
    }
  });
  override(IndexPage.prototype, 'hero', function (original) {
    if (app.current.get('routeName') === 'byobuPrivate') {
      return m(PrivateHero, null);
    }
    return original();
  });
}
flarum.reg.add('fof-byobu', 'forum/pages/PrivateDiscussionsPage', PrivateDiscussionsPage);